import ImageGeneric from "@/assets/images/lg.png";
import { ModalBase } from "@/components/ModalBase/ModalBase";
import type {
  ChatCallConfirmationResult,
  ChatCallParticipant,
} from "@/types/chatCall";

interface CallConfirmationModalProps {
  open: boolean;
  participant: ChatCallParticipant | null;
  result?: ChatCallConfirmationResult | null;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onRetry: () => void;
}

export function CallConfirmationModal({
  open,
  participant,
  result = null,
  isSubmitting = false,
  onCancel,
  onConfirm,
  onRetry,
}: CallConfirmationModalProps) {
  return (
    <ModalBase
      open={open}
      onOpenChange={(next) => {
        if (!next && !isSubmitting) {
          onCancel();
        }
      }}
      title={result?.title || "Confirmar chamada de voz"}
      closeOnOverlayClick={!isSubmitting}
      closeOnEsc={!isSubmitting}
      size="sm"
    >
      <div className="rounded-[28px] bg-white p-6 shadow-xl">
        <div className="flex flex-col items-center gap-4 text-center">
          <img
            src={participant?.avatarUrl || ImageGeneric}
            alt={participant?.name || "Usuário"}
            className="h-20 w-20 rounded-full object-cover"
          />

          <div className="space-y-1">
            <p className="text-sm font-medium text-azul-400">
              {result ? "Chamada não iniciada" : "Chamada de voz"}
            </p>
            <h2 className="text-xl font-semibold text-gray-900">
              {participant?.name} {participant?.lastName}
            </h2>
            {result ? (
              <p className="text-sm text-gray-500" role="status">
                {result.message}
              </p>
            ) : (
              <p className="text-sm text-gray-500">
                Deseja iniciar uma chamada de voz com{" "}
                <span className="font-medium text-gray-700">
                  {participant?.name} {participant?.lastName}
                </span>
                ?
              </p>
            )}
          </div>

          <div className="mt-2 flex w-full gap-3">
            <button
              type="button"
              onClick={onCancel}
              disabled={isSubmitting}
              className="flex-1 rounded-full border border-cinza-200 px-4 py-3 text-sm font-medium text-gray-600 transition-colors hover:bg-cinza-100 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {result ? "Fechar" : "Cancelar"}
            </button>
            <button
              type="button"
              onClick={result ? onRetry : onConfirm}
              disabled={isSubmitting}
              className="flex-1 rounded-full bg-[#153ECE] px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-azul-500 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {isSubmitting
                ? "Ligando..."
                : result
                  ? "Tentar novamente"
                  : "Ligar"}
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  );
}
